import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "component", "ordered", "spacing"];
import React from 'react';
import classNames from 'classnames';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { ListSpacingContext } from './Li';
import styles from './List.module.less';

/**
 * Standard list component. Lists can help make content really scannable within a
 * long article or complex layout. Choose to display ordered or unordered lists of
 * information as it makes sense to your use case.
 */
export var List = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      component = _ref.component,
      _ref$ordered = _ref.ordered,
      ordered = _ref$ordered === void 0 ? false : _ref$ordered,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('List', {
    className: className
  });
  var Component = component || (ordered ? 'ol' : 'ul');
  return /*#__PURE__*/React.createElement(Component, _extends({
    "data-currency": "List",
    className: classNames(className, styles.list, Component === 'ol' && styles['list--ordered'], Component === 'ul' && styles['list--unordered']) // @ts-expect-error -- type error is caused by the fact that we don't know
    // statically if this component will use `<ul>` or `<ol>`, so the ref
    // doesn't have the correct type.
    ,
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(ListSpacingContext.Provider, {
    value: spacing
  }, children));
});
List.displayName = 'List';